/* h2パーツ用のdivを動的に生成
---------------------------------------------- */
export const HEADING_DIV = {
  init: function (elements) {
    $('.c-box--layout02').wrapInner('<div class="c-box--layout02__child-wrap">')
  },
}
